const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Footer/Footer.tsx';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';
import * as React from 'react';

export const Footer = () => {
    const configuration = getConfiguration();
    const configuredFooter = React.createElement(configuration.footer, {});
    return configuredFooter;
};
